module.exports = __webpack_public_path__ + "img/13.cbc2bc21.png";